import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledContactButton = styled(Ds.Button)`
    justify-content: space-between;
    padding: 0.75rem;
    max-height: initial;
`;

export const StyledTextContainer = styled.span`
    display: flex;
    flex-direction: column;
    align-items: start;
    overflow-wrap: anywhere;
    hyphens: auto;
`;

export const StyledFullWidthFlex = styled(Ds.Flex)`
    width: 100%;
    text-align: start;
`;
